// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ModificationInfo_Wrapper__ySnGZ","Element":"ModificationInfo_Element__EOawR","Hr":"ModificationInfo_Hr__4p1Tp"};